"use client"

import UnderlineLink from "@modules/common/components/interactive-link"
import { useFrontendPreferences } from "@lib/frontend-preferences"

const AccountSupport = () => {
  const { locale, t } = useFrontendPreferences()

  return (
    <div
      className="sahil-account-support sahil-acc-card flex flex-col small:flex-row small:items-center justify-between p-6 small:p-8 gap-6"
      dir={locale === "fa" ? "rtl" : "ltr"}
    >
      <div>
        <h3 className="sahil-acc-title !text-2xl mb-2">{t.account.supportTitle}</h3>
        <span className="txt-medium">{t.account.supportBody}</span>
      </div>
      <div>
        <UnderlineLink href="/customer-service">
          {t.account.customerService}
        </UnderlineLink>
      </div>
    </div>
  )
}

export default AccountSupport
